import type { IconData } from '@stacksjs/iconify-core'

export const codingAppWebsiteUi: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M1.52 7.62h28.96v22.85H32V1.52h-1.52v4.57H1.52V1.52H0v28.95h1.52z\"/><path fill=\"currentColor\" d=\"M1.52 30.47h28.96V32H1.52Zm19.81-4.57h6.1v1.53h-6.1Zm0-3.05h6.1v1.53h-6.1ZM4.57 10.66v9.15h22.86v-9.15Zm21.33 7.62H15.24v-1.52h-1.53v1.52H6.09v-6.09h15.24v1.52h1.53v-1.52h3.04Z\"/><path fill=\"currentColor\" d=\"M18.29 13.71h3.04v1.52h-3.04Zm-3.05 1.52h3.05v1.53h-3.05ZM4.57 25.9h12.19v1.53H4.57Zm0-3.05h12.19v1.53H4.57ZM9.14 3.04h1.53v1.53H9.14ZM7.62 13.71h3.05v3.05H7.62ZM6.09 3.04h1.53v1.53H6.09Zm-3.04 0h1.52v1.53H3.05ZM1.52 0h28.96v1.52H1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default codingAppWebsiteUi
